export default __webpack_public_path__ + "static/p3-d09da156a95f2a04137ed8393f4c4889.jpg";